import Action from '../action';

export const REFRESH_ASSET_DASH_BOARD_DATA = '@asset-details/GET_ASSET_DASH_BOARD_DATA';

export const GET_ASSET_DATA = '@asset-details/GET_ASSET_DATA';
export const GET_ASSET_DATA_FAILED = '@asset-details/GET_ASSET_DATA_FAILED';
export const GET_ASSET_DATA_SUCCESS = '@asset-details/GET_ASSET_DATA_SUCCESS';

export const GET_SERIES_DATA = '@asset-details/GET_SERIES_DATA';
export const GET_SERIES_DATA_FAILED = '@asset-details/GET_SERIES_DATA_FAILED';
export const GET_SERIES_DATA_SUCCESS = '@asset-details/GET_SERIES_DATA_SUCCESS';

export const SELECT_SERIES = '@asset-details/SELECT_SERIES';
export const DESELECT_SERIES = '@asset-details/DESELECT_SERIES';

export const SET_DATE_RANGE = '@asset-details/SET_DATE_RANGE';
export const SET_DATE_RANGE_BY_OPTION = '@asset-details/SET_DATE_RANGE_BY_OPTION';

export const SET_ACTIVE_DATA_TAB = '@asset-details/SET_ACTIVE_DATA_TAB';
export const UPDATE_ASSET_LOCATION = '@asset-details/UPDATE_ASSET_LOCATION';

export const getAssetData = assetId => Action(GET_ASSET_DATA, assetId);
export const refreshAssetdashBoardData = assetId => Action(REFRESH_ASSET_DASH_BOARD_DATA, assetId);
export const getAssetDataSuccess = (data, user, included, moreData) =>
  Action(GET_ASSET_DATA_SUCCESS, {data, user, included, moreData});
export const getAssetDataFailed = error => Action(GET_ASSET_DATA_FAILED, error);
export const selectSeries = seriesId => Action(SELECT_SERIES, seriesId);
export const deselectSeries = seriesId => Action(DESELECT_SERIES, seriesId);

export const setDateRange = (start, end) => Action(SET_DATE_RANGE, [start, end]);
export const setDateRangeByOption = optionValue => Action(SET_DATE_RANGE_BY_OPTION, optionValue);

export const getSeriesData = updateDateRange => Action(GET_SERIES_DATA, {updateDateRange});
export const getSeriesDataSuccess = (seriesList, dataFor) => Action(GET_SERIES_DATA_SUCCESS, {seriesList, dataFor});
export const getSeriesDataFailed = error => Action(GET_SERIES_DATA_FAILED, error);
export const setActiveDataTab = (tabKey = 'chart') => Action(SET_ACTIVE_DATA_TAB, tabKey);

export const updateAssetLocation = lastgpsVal => Action(UPDATE_ASSET_LOCATION, lastgpsVal);
